import { IItem } from '@/interfaces/IItem';
import { normalizeText, splitTerms } from '@/domain/pos/search-normalize';
import { ICatalogSection } from './catalog-view';

/**
 * Search on the Menú page (plan §5.6): every term must appear in the
 * product's name, description or category name, accents and case ignored.
 * The index is rebuilt only when the catalog changes (the caller memoises it
 * on `menuStore.catalogRevision`).
 */
export type TCatalogSearchIndex = ReadonlyMap<number, string>;

export function buildSearchIndex(
  sections: readonly ICatalogSection[]
): TCatalogSearchIndex {
  const index = new Map<number, string>();
  for (const { category, items } of sections)
    for (const item of items)
      index.set(
        item.id,
        normalizeText(`${item.name} ${item.description ?? ''} ${category.name}`)
      );
  return index;
}

/** A matcher for the query; null when the query has no terms. */
export function searchMatcher(
  index: TCatalogSearchIndex,
  query: string
): ((item: IItem) => boolean) | null {
  const terms = splitTerms(query);
  if (!terms.length) return null;
  return (item) => {
    const haystack = index.get(item.id);
    return !!haystack && terms.every((term) => haystack.includes(term));
  };
}
